import { type FunctionComponent } from 'react';
import { useIntl } from 'dibs-react-intl';
import { formatRelativeDate, type RelativeMode } from './formatRelativeDate.ts';

type Props = {
    value: Date | string;
    mode?: RelativeMode;
};

const RelativeDateFormat: FunctionComponent<Props> = ({ value, mode }) => {
    const intl = useIntl();
    return (
        <span
            title={intl.formatDate(value, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            })}
        >
            {formatRelativeDate(intl, value, { ...(mode && { mode }) })}
        </span>
    );
};

export default RelativeDateFormat;
